import { useMemo, useState } from 'react';

export const useFormState = (fields?: { id: string; value?: any }[]) => {
  // Compute the original values from the fields
  const originalValues = useMemo(
    () =>
      fields
        ? fields.reduce((acc, field) => {
            acc[field.id] = Array.isArray(field.value)
              ? field.value.join(', ')
              : field.value || '';
            return acc;
          }, {} as Record<string, string>)
        : {},
    [fields],
  );

  // Manage the current input values
  const [inputValue, setInputValue] = useState(originalValues);

  // Determine if any value has changed
  const allowSave = useMemo(
    () =>
      Object.keys(originalValues).some(
        (key) => originalValues[key] !== inputValue[key],
      ),
    [originalValues, inputValue],
  );

  // Function to update input values
  const handleInputChange = (id: string, value: string) => {
    setInputValue((prev) => ({
      ...prev,
      [id]: value,
    }));
  };

  return { originalValues, inputValue, allowSave, handleInputChange };
};
